import { Directive } from '@angular/core';

/**
 * Directive for tracking and contains the Customize template for table.
 * If there are some common Custom for these cells => put here for down grade the code to render in table.component
 * flexible to render and easier to make dynamic template.
 */
@Directive({
  selector: '[appCustomTableCell]'
})
export class CustomTableCellDirective {
  public constructor() {}
}
